import React from 'react';
import { useRouter } from 'next/router';

import cx from 'classnames';

import { useBnplBanner } from 'hooks/bnpl/useBnplBanner';
import { useGGTheme } from 'hooks/theme/useGGTheme';

import { BuyNowPayLaterBanner } from 'routes/home/components/BuyNowPayLaterBanner/BuyNowPayLaterBanner';

import { CanvasFooter } from '../CanvasFooter/CanvasFooter';
import { CanvasNavigation } from '../Navigation/CanvasNavigation';

import s from './CanvasLayout.module.css';

interface TProps {
  children: React.ReactNode;
}

const CanvasLayout = ({ children }: TProps) => {
  const router = useRouter();
  const isBookingFlow =
    router.pathname === '/book' ||
    router.pathname === '/waitlist' ||
    router.pathname === '/multi-book';
  const isBookNow = router.pathname === '/booking-flow';
  const step = router.query.step;
  const { themeMode, theme } = useGGTheme();

  const isSandPalette = theme && theme.palette.name === 'Sand';
  const isEnergyPalette = theme && theme.palette.name === 'Energy';

  const isDarkMode = themeMode === 'dark';

  let stepClass = '';

  if (typeof step === 'string') {
    stepClass =
      {
        'select-location': s.selectLocation,
        'select-time': s.selectTime,
        success: s.success,
        // Add more mappings as needed
      }[step] || '';
  }

  const {
    elementRef,
    showBanner,
    bannerContainerStyle,
    onDismissBanner,
    isDismissed,
    isLoading,
    bnplCapabilities,
  } = useBnplBanner();

  return (
    <div
      className={cx(s.canvas, {
        [s.lightMode]: isBookingFlow && !isDarkMode,
        [s.darkMode]: isBookingFlow && isDarkMode,
        [stepClass]: !!stepClass,
        [s.bookingFlowPage]: isBookNow,
        [s.bookingFlow]: isBookingFlow,
        [s.sandPalette]: isSandPalette,
        [s.energyPalette]: isEnergyPalette,
      })}
      style={bannerContainerStyle}
    >
      {showBanner && (
        <BuyNowPayLaterBanner
          ref={elementRef}
          isDismissed={isDismissed}
          onDismissBanner={onDismissBanner}
          capabilities={bnplCapabilities}
          isLoading={isLoading}
        />
      )}
      <CanvasNavigation />
      <div className={s.layout}>
        {children}
        <CanvasFooter />
      </div>
    </div>
  );
};

export { CanvasLayout };
